import { Component, EventEmitter, Input, Output } from '@angular/core'
import { DatePipe } from '@angular/common'
import { RelatedTransaction } from '../../models'
import { StatusBadgeComponent } from '../status-badge/status-badge.component'
import { NegativeCurrencyPipe } from '../../pipes/negative-currency.pipe'

@Component({
    selector: 'ach-related-transactions',
    standalone: true,
    imports: [DatePipe, StatusBadgeComponent, NegativeCurrencyPipe],
    templateUrl: './related-transactions.component.html',
    styleUrl: './related-transactions.component.scss',
})
export class RelatedTransactionsComponent {
    @Input({ required: true }) relatedTransactions: RelatedTransaction[] = []
    @Output() transactionSelected = new EventEmitter<string>()
}
